<template>
  <v-textarea
    class="textarea-ref"
    :label="labelComputed"
    :value="safeValue"
    :rows="rowsComputed"
    dense
    outlined
    readonly
    auto-grow
    :no-resize="noResize"
  ></v-textarea>
</template>

<script>
export default {
  name: 'TextAreaRef',

  components: {},

  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
      default: '',
    },
    rows: {
      type: [Number, String],
      required: false,
    },
    noResize: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {}
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    safeValue() {
      // 項目未入力時にラベルが大きく表示されるのを抑止するため
      // 未入力の場合は代替文字列をセット
      return this.value ? this.value : ' '
    },
    rowsComputed() {
      return this.rows
    },
    labelComputed() {
      return this.label
    },
  },

  methods: {},

  mounted() {},
}
</script>
<style>
/** ラベルの文字色指定 */
.textarea-ref div.v-text-field__slot label {
  color: rgba(0, 0, 0);
}
/** 入力値の文字色指定 */
.textarea-ref div.v-text-field__slot label {
  color: rgba(0, 0, 0);
  font-size: 100%;
}
/** ボーダー色指定 */
.textarea-ref > .v-input__control > .v-input__slot > fieldset {
  border-style: solid;
  border-width: 1px;
  border-color: #bdbdbd;
}
/** エラーメッセージ領域を非表示 */
.textarea-ref > .v-input__control > .v-text-field__details {
  display: none;
}
</style>
